import { ScheduleDocument } from "../../interfaces/ISchedules";
import LocationDateInfo from "../competitions/LocationDateInfo";
import { Grid, TableCell, Typography } from "@mui/material";

function formatScheduleDate(schedule: ScheduleDocument): string | undefined {
  const raw = schedule.date;
  if (raw == null || raw === "") {
    return undefined;
  }
  if (typeof raw === "string") {
    return raw;
  }
  if (typeof raw === "object" && raw !== null && "toDate" in raw && typeof (raw as { toDate: () => Date }).toDate === "function") {
    const d = (raw as { toDate: () => Date }).toDate();
    if (d instanceof Date && !Number.isNaN(d.getTime())) {
      return d.toLocaleDateString("pl-PL");
    }
  }
  return String(raw);
}

/** Wiersz listy dni harmonogramu (widok wyboru dnia). */
export default function ScheduleDayListRow({ schedule }: { schedule: ScheduleDocument }) {
  const primary = schedule.dayLabel || `Dzień ${schedule.day}`;
  const dateStr = formatScheduleDate(schedule);

  return (
    <TableCell sx={{ py: 1.5 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            component="div"
            color="primary"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              lineHeight: 1.3,
              wordBreak: "break-word",
              mb: dateStr ? { xs: 0.5, sm: 0.5 } : 0,
            }}
          >
            {primary}
          </Typography>
          {dateStr && <LocationDateInfo date={dateStr} />}
        </Grid>
      </Grid>
    </TableCell>
  );
}
